import {
  CarryOutFilled,
  SketchOutlined,
  LineChartOutlined,
  DashboardOutlined,
} from '@ant-design/icons';
import { APP_PREFIX_PATH } from 'configs/AppConfig';

const mainMenuNavTree = [
  {
    key: 'main-menu',
    path: `${APP_PREFIX_PATH}`,
    title: 'sidenav.main-menu',
    breadcrumb: false,
    isEnabled: true,
    submenu: [
      {
        key: 'Dashboard',
        path: `${APP_PREFIX_PATH}/dashboard`,
        title: 'sidenav.main-menu.dashboard',
        icon: DashboardOutlined,
        isEnabled: true,
        submenu: [],
      },
      {
        key: '999 Wafer | Silver Coin',
        path: `${APP_PREFIX_PATH}/999-wafer-silver-coin`,
        title: 'sidenav.main-menu.wafer-silver-coin-price',
        icon: SketchOutlined,
        breadcrumb: true,
        isEnabled: true,
        submenu: [],
      },
      {
        key: 'Retail Gold Price',
        path: `${APP_PREFIX_PATH}/retail-gold-price`,
        title: 'sidenav.main-menu.retail-gold-price',
        icon: SketchOutlined,
        breadcrumb: true,
        isEnabled: true,
        submenu: [],
      },

      {
        key: 'Action History',
        path: `${APP_PREFIX_PATH}/action-history`,
        title: 'sidenav.main-menu.action-history',
        icon: CarryOutFilled,
        breadcrumb: true,
        submenu: [],
      },
      {
        key: 'Price Feed',
        title: 'sidenav.main-menu.price-feed',
        icon: LineChartOutlined,
        breadcrumb: true,
        isEnabled: true,
        submenu: [
          {
            key: 'Manual Cut Off',
            path: `${APP_PREFIX_PATH}/manual-cut-off`,
            title: 'sidenav.main-menu.price-feed.manual-cut-off',
            breadcrumb: false,
            isEnabled: true,
            submenu: [],
          },
          {
            key: 'Manual Override',
            title: 'sidenav.main-menu.price-feed.manual-override',
            path: `${APP_PREFIX_PATH}/manual-override`,
            breadcrumb: false,
            isEnabled: true,
            submenu: [],
          },
          {
            key: 'Setups',
            title: 'sidenav.main-menu.price-feed.setups',
            breadcrumb: false,
            isEnabled: true,
            submenu: [
              {
                key: 'Circuit Breaker Setup',
                path: `${APP_PREFIX_PATH}/setups/feed-setup`,
                title: 'sidenav.main-menu.price-feed.setups.feed-setup',
                submenu: [],
                isEnabled: true,
              },
              {
                key: 'Tomei Price Setup',
                path: `${APP_PREFIX_PATH}/setups/tomei-price-setup`,
                title: 'sidenav.main-menu.price-feed.setups.tomei-price-setup',
                submenu: [],
                isEnabled: true,
              },
            ],
          },
          {
            key: 'Reports',
            title: 'sidenav.main-menu.price-feed.reports',
            breadcrumb: true,
            isEnabled: true,
            submenu: [
              {
                key: 'Feed Price Summary',
                path: `${APP_PREFIX_PATH}/reports/feed-price-summary`,
                title:
                  'sidenav.main-menu.price-feed.reports.feed-price-summary',
                breadcrumb: false,
                isEnabled: true,
                submenu: [],
              },
              {
                key: 'Feed Price History',
                path: `${APP_PREFIX_PATH}/reports/feed-price-history`,
                title:
                  'sidenav.main-menu.price-feed.reports.feed-price-history',
                breadcrumb: false,
                isEnabled: true,
                submenu: [],
              },
              {
                key: 'Circuit Breaker Setup History',
                path: `${APP_PREFIX_PATH}/reports/feed-price-setup-history`,
                title:
                  'sidenav.main-menu.price-feed.reports.feed-price-setup-history',
                breadcrumb: false,
                isEnabled: true,
                submenu: [],
              },
              {
                key: 'Tomei Price Summary',
                path: `${APP_PREFIX_PATH}/reports/tomei-price-summary`,
                title:
                  'sidenav.main-menu.price-feed.reports.tomei-price-summary',
                breadcrumb: false,
                isEnabled: true,
                submenu: [],
              },
              {
                key: 'Tomei Price History',
                path: `${APP_PREFIX_PATH}/reports/tomei-price-history`,
                title:
                  'sidenav.main-menu.price-feed.reports.tomei-price-history',
                breadcrumb: false,
                isEnabled: true,
                submenu: [],
              },
              {
                key: 'Manual Price Activation History',
                path: `${APP_PREFIX_PATH}/reports/manual-price-activation-history`,
                title:
                  'sidenav.main-menu.price-feed.reports.manual-price-activation-history',
                breadcrumb: false,
                isEnabled: true,
                submenu: [],
              },
              {
                key: 'Feed Cut Off History',
                path: `${APP_PREFIX_PATH}/reports/cut-off-history`,
                title: 'sidenav.main-menu.price-feed.reports.cut-off-history',
                breadcrumb: false,
                isEnabled: true,
                submenu: [],
              },
            ],
          },
        ],
      },
      {
        key: 'Application Log',
        path: `${APP_PREFIX_PATH}/application-log`,
        title: 'sidenav.main-menu.application-log',
        icon: CarryOutFilled,
        breadcrumb: true,
        submenu: [],
      },
    ],
  },
];

const navigationConfig = [...mainMenuNavTree];

export default navigationConfig;
